


import React from 'react';
import { useTranslation } from 'react-i18next';

import logo from '../assets/logoFooter.png';
import facebookIcon from '../assets/fac.png';
import instagramIcon from '../assets/instagram.png';
import tiktok_logo from '../assets/tiktok_logo.png';
import hponeIcon from '../assets/phone-icon.png'
import '../styles/Footer.css';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  return (
    <footer className={`footer ${language === 'ar' ? 'rtl' : 'ltr'}`}>
      <div className="footer-content">
        <div className="footer-left">
          <img src={logo} alt="Excellence VIP Services Logo" className="footer-logo" />
          <p>{t('footerDescription')}</p>
        </div>

        <div className="footer-center">
          <ul>
            <li><a href="#home">{t('home')}</a></li>
            <li><a href="#Apartment">{t('Logement')}</a></li>
            <li><a href="#about">{t('services')}</a></li>
            <li><a href="#extra">{t('aboutUs')}</a></li>
            <li><a href="#experiences">{t('experiences')}</a></li>
            <li><a href="#vipContact">{t('contact')}</a></li>
          </ul>
        </div>

        <div className="footer-right">

          <ul>
            <li><a href="#">{t('terms')}</a></li>
            <li><a href="#">{t('privacy')}</a></li>
            <li><a href="#">{t('cookies')}</a></li>

            {/* <li>
              <a href="mailto:kasbahmagic@gmail.com" className="footer-email">
                
                
                ✉ {t('')} : kasbahmagic@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:+33 665753833" className="footer-phone">
                <img
                  src={hponeIcon}
                  alt="hponeIcon"
                  className="phone-icon"
                />
                {t('')} : +33 665753833
              </a>
            </li> */}
            <li>
              <a href="mailto:kasbahmagic@gmail.com" className={`footer-email ${language === 'ar' ? 'rtl-align' : ''}`}>
                ✉ {t('')} : kasbahmagic@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:+33 665753833" className={`footer-phone ${language === 'ar' ? 'rtl-align' : ''}`}>
                <img src={hponeIcon} alt="Phone" className="phone-icon" />
                {t(' ')} :  +33 665753833
              </a>
            </li>



          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('copyright', { year: new Date().getFullYear() })}</p>
        <div className="social-icons">


          <a href="https://www.facebook.com/profile.php?id=61573397745297&locale=fr_FR" aria-label="Facebook" className="social-icon">
            <img src={facebookIcon} alt="Facebook" />
          </a>

          <a href="https://www.instagram.com/kasbahmagic/" aria-label="Instagram" className="social-icon">
            <img src={instagramIcon} alt="Instagram" />
          </a>

          <a href="https://www.tiktok.com/@kasbahmagic" aria-label="tiktok_logo" className="social-icon">
            <img src={tiktok_logo} alt="tiktok_logo" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
